import React, { useEffect, useState } from "react"
import { Card, Col, Form, Input, Label, Row } from "reactstrap"
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import Dropzone from "react-dropzone"
import { formatBytes } from "utils/common-helpers"
import axios from "axios"
import Swal from "sweetalert2"
import configure from "configure"
import Loader from "pages/Separate/Loader"
import bug from "../../../assets/images/flags/bug-icon.png"
import Suggestion from "../../../assets/images/flags/sugg-icon.png"
import High from "../../../assets/images/flags/high.png"
import Medium from "../../../assets/images/flags/medium.png"
import Low from "../../../assets/images/flags/low.png"
import { Tooltip } from "antd"
import { useSelector } from "react-redux"
import Select from "react-select"

const TicketEdit = ({ closeModal, ticketDetails, refreshList }) => {
  const generalData = useSelector(state => state?.GeneralData?.generalData)

  const [isLoading, setLoading] = useState(false)
  const [title, setTitle] = useState("")
  const [type, setType] = useState("0")
  const [priority, setPriority] = useState("low")
  const [description, setDescription] = useState("")
  const [addedBy, setAddedBy] = useState(null)
  const [selectedFiles1, setselectedFiles1] = useState([])

  // Populate fields when ticketDetails changes
  useEffect(() => {
    if (ticketDetails) {
      setTitle(ticketDetails.subject || "")
      setType(ticketDetails.type?.toString() || "0")
      setPriority(ticketDetails.priority || "low")
      setDescription(ticketDetails.description || "")
      setAddedBy(
        generalData?.staff?.find(
          obj =>
            obj?.value ==
            (ticketDetails.added_by || localStorage.getItem("auth_id"))
        )
      )
      // Prepopulate uploaded files (if any)
      if (ticketDetails.files && ticketDetails.files.length > 0) {
        const files = ticketDetails.files.map(f => ({
          ...f,
          preview: f.url || f.file_url, // Use existing file URLs
          name: f.name || f.filename,
        }))
        setselectedFiles1(files)
      }
    }
  }, [ticketDetails, generalData])

  // Handle new file uploads
  const handleAcceptedFiles1 = files => {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    )
    setselectedFiles1(files)
  }

  const onUpdateTicket = async e => {
    e.preventDefault()
    if (type && priority) {
      if (description?.length > 40) {
        Swal.fire({
          icon: "warning",
          title: "Are You Sure?",
          text: `You want to update this ${
            type == 0 ? "Bug" : "Suggestion"
          } ticket`,
          showCancelButton: true,
          confirmButtonText: "Yes, Update it!",
          cancelButtonText: "No, cancel!",
        }).then(async result => {
          if (result?.isConfirmed) {
            setLoading(true)
            const formData = new FormData()
            formData.append("ticket_id", ticketDetails?.id)
            formData.append(
              "user_id",
              addedBy?.value || localStorage.getItem("auth_id")
            )
            formData.append("subject", title)
            formData.append("description", description)
            formData.append("type", type)
            formData.append("priority", priority)

            if (selectedFiles1?.length !== 0) {
              for (let i = 0; i < selectedFiles1.length; i++) {
                const file = selectedFiles1[i]

                // 🛑 Skip preloaded files (they already exist on server / OneDrive)
                if (!file.originFileObj && !(file instanceof File)) {
                  continue
                }

                const originalFile =
                  file instanceof File ? file : file.originFileObj

                if (!originalFile) continue // extra safety

                const newName = originalFile.name.replace(
                  /\s*at\s*\d{1,2}\.\d{2}\.\d{2}\s*(AM|PM)/i,
                  ""
                )

                const newFile = new File([originalFile], newName, {
                  type: originalFile.type,
                })

                formData.append("files[]", newFile)
              }
            }

            try {
              const res = await axios({
                method: "post",
                url: `${configure.nodeApi}/editEarthTicket`,
                data: formData,
                headers: {
                  Accept: "application/json",
                  "Content-Type": "multipart/form-data",
                },
              })
              setLoading(false)
              if (res?.data?.success) {
                Swal.fire({
                  icon: "success",
                  text: "Ticket Updated Successfully",
                }).then(() => {
                  closeModal(false)
                  refreshList && refreshList()
                })
              }
            } catch (error) {
              console.log(error)
              setLoading(false)
            }
          }
        })
      } else {
        Swal.fire({
          icon: "warning",
          text: "Description must be at least 40 characters long",
        })
      }
    } else {
      Swal.fire({
        icon: "warning",
        text: "Kindly Complete All Required Fields",
      })
    }
  }

  return (
    <div>
      {isLoading && <Loader />}
      <div className="modal-body p-2">
        <Form
          className="row d-flex justify-content-center align-items-center"
          onSubmit={onUpdateTicket}
        >
          <div className="col-md-12 d-flex flex-column new-task-modal mt-4 ">
            <div className="row">
              {/* Title */}
              <div className="col-sm-10 ps-2 mb-4">
                <Label>
                  Title <span className="text-danger">*</span>
                </Label>
                <Input
                  type="text"
                  className="form-control"
                  placeholder="Enter Title"
                  value={title}
                  onChange={e => setTitle(e.target.value)}
                  required
                />
              </div>

              {/* Type */}
              <div className="col-sm-2 ps-2 mb-4">
                <Label>Type</Label>
                <div className="d-flex gap-4 mt-2">
                  <Tooltip title="Bug" color="#752b97">
                    <a
                      className={`${type === "0" ? "blinking-icon" : ""}`}
                      onClick={() => setType("0")}
                    >
                      <img src={bug} alt="Bug" width={25} height={25} />
                    </a>
                  </Tooltip>
                  <Tooltip title="Suggestion" color="#752b97">
                    <a
                      className={`${type === "1" ? "blinking-icon" : ""}`}
                      onClick={() => setType("1")}
                    >
                      <img
                        src={Suggestion}
                        alt="Suggestion"
                        width={25}
                        height={25}
                      />
                    </a>
                  </Tooltip>
                </div>
              </div>

              {/* Priority */}
              <div className="col-sm-3 ps-2 mb-4">
                <Label>
                  Priority <span className="text-danger">*</span>
                </Label>
                <div className="d-flex gap-3 mt-2">
                  <Tooltip title="High" color="#752b97">
                    <a
                      className={`${
                        priority === "high" ? "blinking-icon" : ""
                      }`}
                      onClick={() => setPriority("high")}
                    >
                      <img src={High} alt="High" width={25} height={25} />
                    </a>
                  </Tooltip>
                  <Tooltip title="Medium" color="#752b97">
                    <a
                      className={`${
                        priority === "medium" ? "blinking-icon" : ""
                      }`}
                      onClick={() => setPriority("medium")}
                    >
                      <img src={Medium} alt="Medium" width={25} height={25} />
                    </a>
                  </Tooltip>
                  <Tooltip title="Low" color="#752b97">
                    <a
                      className={`${priority === "low" ? "blinking-icon" : ""}`}
                      onClick={() => setPriority("low")}
                    >
                      <img src={Low} alt="Low" width={25} height={25} />
                    </a>
                  </Tooltip>
                </div>
              </div>

              {/* Attachments */}
              <div className="col-md-8 d-flex justify-content-start align-items-center gap-3 mb-4">
                <div className="col-md-5 col-sm-12">
                  <label>Attachment</label>
                  <Dropzone onDrop={handleAcceptedFiles1}>
                    {({ getRootProps, getInputProps }) => (
                      <div
                        className="dz-message needsclick p-0"
                        {...getRootProps()}
                      >
                        <input {...getInputProps()} />
                        <div className="d-flex px-2 custom-file-upload align-items-center">
                          <i className="display-6 text-muted bx bxs-cloud-upload" />
                          <h6 className="mb-0 ms-2">Upload Files</h6>
                        </div>
                      </div>
                    )}
                  </Dropzone>
                </div>

                {selectedFiles1.length > 0 && (
                  <div className="dropzone-previews d-block" id="file-previews">
                    <label className="mb-1">Uploaded Files</label>
                    <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                      <Row className="align-items-center justify-content-evenly">
                        {selectedFiles1.map((f, i) => (
                          <Col key={i} className="col-auto">
                            <img
                              height="70"
                              className="avatar-sm rounded bg-light"
                              alt={f.name}
                              src={f.preview || f.url}
                            />
                          </Col>
                        ))}
                      </Row>
                    </Card>
                  </div>
                )}

                {/* Raised By */}
                {(localStorage.getItem("auth_id") == 1 ||
                  localStorage.getItem("auth_id") == 63 ||
                  localStorage.getItem("auth_id") == 188) && (
                  <div className="col-4 ml-8">
                    <Label>Raised By</Label>
                    <Select
                      placeholder="Select Member"
                      className="basic-multi-select"
                      classNamePrefix="select"
                      options={generalData?.staff}
                      value={addedBy}
                      onChange={setAddedBy}
                      isClearable
                    />
                  </div>
                )}
              </div>

              {/* Description */}
              <div className="col-12 ps-2 mb-4">
                <label>Description</label>
                <CKEditor
                  editor={ClassicEditor}
                  data={description || ""}
                  onChange={(event, editor) => setDescription(editor.getData())}
                />
              </div>
            </div>
          </div>

          <div className="text-end">
            <button className="btn btn-save btn-label">
              <i className="fas fa-save me-2 label-icon"></i>
              Update
            </button>
          </div>
        </Form>
      </div>
    </div>
  )
}

export default TicketEdit
